import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const RefundPage = () => {
  return (
    <div className="min-h-screen bg-[#050508]" data-testid="refund-page">
      <Navbar />

      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl text-white mb-8">Refund Policy</h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#A1A1AA]">
            <section>
              <h2 className="font-heading text-xl text-white mb-4">1. Digital Products</h2>
              <p>
                Due to the digital nature of our products, all sales are final once a license key has 
                been delivered. License keys are delivered instantly upon successful payment.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">2. Eligibility for Refund</h2>
              <p>
                Refunds may be considered in the following circumstances:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Product is not delivered within 24 hours of payment</li>
                <li>Product is detected at the time of purchase (check Status page)</li>
                <li>Technical issues preventing product use that cannot be resolved by support</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">3. Non-Refundable Situations</h2>
              <p>
                Refunds will not be provided for:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Change of mind after purchase</li>
                <li>Game bans or account suspensions</li>
                <li>Products that become detected after purchase</li>
                <li>Expired license keys</li>
                <li>Violation of Terms of Service</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">4. How to Request a Refund</h2>
              <p>
                To request a refund, please contact us through our{" "}
                <a href="https://discord.gg/efeySGKGJk" target="_blank" rel="noopener noreferrer" className="text-[#4F7CFF] hover:underline">
                  Discord server
                </a>{" "}
                with the following information:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Your email address used for purchase</li>
                <li>Order ID or license key</li>
                <li>Reason for refund request</li>
                <li>Any relevant screenshots or documentation</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">5. Refund Processing</h2>
              <p>
                Approved refunds will be processed within 5-7 business days. Refunds will be issued 
                to the original payment method used for purchase.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">6. Cryptocurrency Refunds</h2>
              <p>
                For cryptocurrency payments, refunds will be processed in the equivalent USD value 
                at the time of the refund, not the original cryptocurrency amount.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPage;
